import { supabase } from './supabase';

// Ambil semua baris stock untuk sekumpulan menu_item_id sekaligus (efisien untuk grid/listing).
// Key map: menu_item_id (stok level item) atau `${menu_item_id}:${menu_variant_id}` (stok level varian).
export async function getStockMap(menuItemIds) {
  const ids = [...new Set((menuItemIds || []).filter(Boolean))];
  if (ids.length === 0) return {};
  const { data } = await supabase.from('stock').select('*').in('menu_item_id', ids);
  const map = {};
  (data || []).forEach((s) => {
    const key = s.menu_variant_id ? `${s.menu_item_id}:${s.menu_variant_id}` : s.menu_item_id;
    map[key] = s;
  });
  return map;
}

// Ambil baris stock yang relevan untuk 1 item/varian. Prioritas: stok level varian, lalu stok level item.
// Return null kalau item tidak dilacak stoknya (dianggap selalu tersedia / unlimited).
export function resolveStock(stockMap, menuItemId, menuVariantId) {
  if (menuVariantId && stockMap[`${menuItemId}:${menuVariantId}`]) return stockMap[`${menuItemId}:${menuVariantId}`];
  if (stockMap[menuItemId]) return stockMap[menuItemId];
  return null;
}

export function isOutOfStock(stockRow) {
  return !!stockRow && stockRow.qty <= 0;
}

// Cek ketersediaan sekumpulan item cart terhadap stok terkini (dipanggil ulang saat checkout,
// untuk jaga-jaga stok berubah/habis sejak item dimasukkan ke keranjang).
// items: [{ product_id, variant_id, product_name, variant_name, qty }]
// Return { ok: boolean, problems: [{ name, available, requested }] }
export async function verifyCartStock(items) {
  const ids = items.map(i => i.product_id);
  const map = await getStockMap(ids);
  const problems = [];
  for (const i of items) {
    const row = resolveStock(map, i.product_id, i.variant_id);
    if (row && row.qty < i.qty) {
      problems.push({
        name: i.variant_name ? `${i.product_name} – ${i.variant_name}` : i.product_name,
        available: Math.max(0, row.qty),
        requested: i.qty,
      });
    }
  }
  return { ok: problems.length === 0, problems };
}

// Kurangi stok setelah order berhasil dibuat (best-effort, hanya untuk item yang dilacak stoknya).
export async function decrementStockForOrder(items, orderId) {
  const ids = items.map(i => i.product_id);
  const map = await getStockMap(ids);
  for (const i of items) {
    const row = resolveStock(map, i.product_id, i.variant_id);
    if (!row) continue; // tidak dilacak, lewati
    const newQty = Math.max(0, row.qty - i.qty);
    await supabase.from('stock').update({ qty: newQty, updated_at: new Date().toISOString() }).eq('id', row.id);
    await supabase.from('stock_log').insert({
      menu_item_id: i.product_id,
      menu_variant_id: i.variant_id || null,
      delta: -i.qty,
      reason: 'order_web',
      reference_id: orderId,
    });
  }
}
